<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="Guías de Remisión" />

    <div class="flex-grow-1 overflow-auto px-3 pb-3">

      <!-- Filtros + botón nuevo -->
      <div class="card mb-3">
        <div class="card-body py-3">
          <div class="row g-2 align-items-end">
            <div class="col-6 col-md-2">
              <label class="form-label mb-1 small fw-semibold">Desde</label>
              <input v-model="filtros.f1" @change="aplicarFechas" @blur="aplicarFechas" @keyup.enter="aplicarFechas" type="date" class="form-control form-control-sm" />
            </div>
            <div class="col-6 col-md-2">
              <label class="form-label mb-1 small fw-semibold">Hasta</label>
              <input v-model="filtros.f2" @change="aplicarFechas" @blur="aplicarFechas" @keyup.enter="aplicarFechas" type="date" class="form-control form-control-sm" />
            </div>
            <div class="col-6 col-md-2">
              <label class="form-label mb-1 small fw-semibold">Estado</label>
              <select v-model="filtros.estadodoc" @change="cargar" class="form-select form-select-sm">
                <option value="">Todos</option>
                <option value="1">En tránsito</option>
                <option value="2">Recepcionada</option>
                <option value="3">Anulada</option>
              </select>
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label mb-1 small fw-semibold">Nro. Guía</label>
              <input v-model="filtros.q" @input="buscarDebounced" type="text"
                class="form-control form-control-sm" placeholder="0003-0006753" />
            </div>
            <div class="col-6 col-md-1">
              <button @click="limpiar" class="btn btn-sm btn-outline-secondary w-100">
                <img src="../../assets/img/icons/close.svg" alt="X" style="width:14px" />
              </button>
            </div>
            <div class="col-6 col-md-2">
              <button @click="abrirNueva" class="btn btn-sm btn-primary w-100">
                <img src="../../assets/img/icons/add-circle.svg" alt="+" style="width:16px;filter:brightness(0) invert(1)" class="me-1" /> Nueva GR
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Stats -->
      <div class="row g-2 mb-3">
        <div class="col-6 col-md-3">
          <div class="card text-center py-2">
            <div class="small text-muted">Total</div>
            <div class="fw-bold fs-5">{{ stats.total }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="card text-center py-2">
            <div class="small text-muted">Recepcionadas</div>
            <div class="fw-bold fs-5 text-success">{{ stats.recepcionadas }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="card text-center py-2">
            <div class="small text-muted">En tránsito</div>
            <div class="fw-bold fs-5 text-warning">{{ stats.transito }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="card text-center py-2">
            <div class="small text-muted">Anuladas</div>
            <div class="fw-bold fs-5 text-danger">{{ stats.anuladas }}</div>
          </div>
        </div>
      </div>

      <!-- Tabla -->
      <div class="card">
        <div class="card-body p-0">
          <div v-if="cargando" class="text-center py-5 text-muted">
            <div class="spinner-border spinner-border-sm me-2"></div>Cargando…
          </div>
          <div v-else-if="!transferencias.length" class="text-center py-5 text-muted">
            No se encontraron guías con los filtros aplicados.
          </div>
          <div v-else class="table-responsive">
            <table class="table table-hover table-sm mb-0">
              <thead class="table-light">
                <tr>
                  <th class="ps-3">Nro. Guía</th>
                  <th>Origen</th>
                  <th>Destino</th>
                  <th>Fecha</th>
                  <th class="text-center">Estado</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="t in transferencias" :key="t.idreg">
                  <td class="ps-3">
                    <span class="badge bg-light text-dark border font-monospace">
                      {{ numeroGuia(t) }}
                    </span>
                  </td>
                  <td class="small">{{ t.almacen_origen }}</td>
                  <td class="small">{{ t.almacen_destino }}</td>
                  <td class="small">{{ fmtFecha(t.fecha_emision) }}</td>
                  <td class="text-center">
                    <span :class="estadoClass(t.estadodoc, t.estado)">{{ estadoLabel(t.estadodoc, t.estado) }}</span>
                  </td>
                  <td class="text-center">
                    <div class="d-flex gap-1 justify-content-center">
                      <button @click="verDetalle(t)" class="btn btn-xs btn-secondary" title="Ver detalle">
                        <img src="../../assets/img/icons/eye.svg" alt="Ver" style="width:18px;filter:brightness(0) invert(1)" />
                      </button>
                      <!-- Borrador: Emitir -->
                      <button v-if="!t.estado && t.estadodoc===1" @click="accion('emitir', t)"
                        class="btn btn-xs btn-primary" title="Emitir (descuenta stock origen)">
                        <img src="../../assets/img/icons/money-send.svg" alt="Emitir" style="width:18px;filter:brightness(0) invert(1)" />
                      </button>
                      <!-- En tránsito: Recepcionar -->
                      <button v-if="t.estado && t.estadodoc===1" @click="accion('recepcionar', t)"
                        class="btn btn-xs btn-success" title="Recepcionar (suma stock destino)">
                        <img src="../../assets/img/icons/check-icon.svg" alt="✓" style="width:18px;filter:brightness(0) invert(1)" /> Recepcionar
                      </button>
                      <!-- Anular (borrador o en tránsito) -->
                      <button v-if="t.estadodoc!==2 && t.estadodoc!==3" @click="accion('anular', t)"
                        class="btn btn-xs btn-danger" title="Anular">
                        <img src="../../assets/img/icons/close-circle-2.svg" alt="Anular" style="width:18px;filter:brightness(0) invert(1)" />
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="totalPags > 1" class="d-flex justify-content-between align-items-center px-3 py-2 border-top">
            <small class="text-muted">{{ total }} guías</small>
            <div class="d-flex gap-1">
              <button class="btn btn-sm btn-outline-secondary" :disabled="pagina<=1" @click="paginar(pagina-1)">‹</button>
              <span class="btn btn-sm btn-secondary disabled">{{ pagina }} / {{ totalPags }}</span>
              <button class="btn btn-sm btn-outline-secondary" :disabled="pagina>=totalPags" @click="paginar(pagina+1)">›</button>
            </div>
          </div>
        </div>
      </div>

    </div>
    <MainFooter />
  </div>

  <!-- ─── Modal detalle ──────────────────────────────────────────── -->
  <div v-if="detalleModal" class="modal fade show d-block" style="background:rgba(0,0,0,.45);z-index:1055" @click.self="detalleModal=null">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header py-3 border-bottom-0" style="background:#f8f9fa">
          <div class="w-100">
            <div class="d-flex justify-content-between align-items-start mb-3">
              <div>
                <div class="text-muted small mb-1">Guía de Remisión</div>
                <h5 class="fw-bold mb-0">{{ numeroGuia(detalleModal) }}</h5>
              </div>
              <div class="d-flex align-items-center gap-2">
                <span :class="estadoClass(detalleModal.estadodoc, detalleModal.estado)" style="font-size:.85rem;padding:.35em .7em">{{ estadoLabel(detalleModal.estadodoc, detalleModal.estado) }}</span>
                <button class="btn-close btn-sm" @click="detalleModal=null"></button>
              </div>
            </div>
            <!-- Origen → Destino -->
            <div class="d-flex align-items-center gap-2">
              <div class="flex-fill rounded-3 p-2 text-center" style="background:#fff3f3;border:2px solid #f5365c">
                <div class="text-muted" style="font-size:.7rem;letter-spacing:.05em;text-transform:uppercase">Sale de</div>
                <div class="fw-bold" style="color:#f5365c;font-size:.95rem">{{ detalleModal.almacen_origen }}</div>
              </div>
              <div class="text-muted fw-bold fs-5 flex-shrink-0">→</div>
              <div class="flex-fill rounded-3 p-2 text-center" style="background:#f0fff4;border:2px solid #2dce89">
                <div class="text-muted" style="font-size:.7rem;letter-spacing:.05em;text-transform:uppercase">Llega a</div>
                <div class="fw-bold" style="color:#2dce89;font-size:.95rem">{{ detalleModal.almacen_destino }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body pt-3">
          <div v-if="cargandoDetalle" class="text-center py-3"><div class="spinner-border spinner-border-sm"></div></div>
          <div v-else>
            <div class="d-flex gap-4 mb-3 text-center">
              <div>
                <div class="small text-muted">Fecha</div>
                <div class="fw-semibold">{{ fmtFecha(detalleModal.fecha_emision) }}</div>
              </div>
              <div>
                <div class="small text-muted">Ítems</div>
                <div class="fw-bold fs-5">{{ detalleModal.items?.length || 0 }}</div>
              </div>
              <div v-if="detalleModal.observacion">
                <div class="small text-muted">Observación</div>
                <div class="small">{{ detalleModal.observacion }}</div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-sm table-bordered mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Código</th>
                    <th>Producto</th>
                    <th>Talla</th>
                    <th class="text-center">Cant.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in detalleModal.items" :key="item.iddet">
                    <td class="font-monospace small text-nowrap">{{ item.codigo_prov || '—' }}</td>
                    <td class="small transfer-product-name">{{ item.producto || item.presentacion }}</td>
                    <td class="small text-center text-nowrap">{{ item.talla || item.presentacion || '—' }}</td>
                    <td class="text-center fw-semibold">{{ item.cantidad }}</td>
                  </tr>
                  <tr v-if="!detalleModal.items?.length">
                    <td colspan="4" class="text-center text-muted py-3">Sin detalle</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer py-2 gap-2">
          <button v-if="detalleModal.estado && detalleModal.estadodoc===1"
            @click="accion('recepcionar', detalleModal); detalleModal=null"
            class="btn btn-sm btn-success">
            <img src="../../assets/img/icons/check-icon.svg" alt="✓" style="width:14px;filter:brightness(0) invert(1)" class="me-1" />Recepcionar transferencia
          </button>
          <button v-if="!detalleModal.estado && detalleModal.estadodoc===1"
            @click="accion('emitir', detalleModal); detalleModal=null"
            class="btn btn-sm btn-primary">
            <img src="../../assets/img/icons/money-send.svg" alt="→" style="width:16px;filter:brightness(0) invert(1)" class="me-1" />Emitir
          </button>
          <button class="btn btn-sm btn-outline-secondary" @click="detalleModal=null">Cerrar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- ─── Modal nueva GR ─────────────────────────────────────────── -->
  <div v-if="nuevaModal" class="modal fade show d-block" style="background:rgba(0,0,0,.45);z-index:1055" @click.self="cerrarNueva">
    <div class="modal-dialog modal-xl transfer-create-dialog">
      <div class="modal-content transfer-create-modal">
        <div class="modal-header py-2">
          <h6 class="modal-title fw-bold">Nueva Guía de Remisión</h6>
          <button class="btn-close btn-sm" @click="cerrarNueva"></button>
        </div>
        <div class="modal-body">
          <!-- Cabecera GR -->
          <div class="row g-3 mb-2">
            <div class="col-md-3">
              <label class="form-label small fw-semibold">Origen <span class="text-danger">*</span></label>
              <select v-model="nuevaGR.idorigen" @change="cargarSiguienteNumero" class="form-select form-select-sm">
                <option value="">Seleccionar…</option>
                <option :value="1">939 — A.LAPOINT 939</option>
                <option :value="15">1179 — A.LAPOINT 1179</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label small fw-semibold">Destino <span class="text-danger">*</span></label>
              <select v-model="nuevaGR.iddestino" class="form-select form-select-sm">
                <option value="">Seleccionar…</option>
                <option v-if="nuevaGR.idorigen!=1" :value="1">939 — A.LAPOINT 939</option>
                <option v-if="nuevaGR.idorigen!=15" :value="15">1179 — A.LAPOINT 1179</option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label small fw-semibold">Fecha <span class="text-danger">*</span></label>
              <input v-model="nuevaGR.fecha_emision" type="date" class="form-control form-control-sm" />
            </div>
            <div class="col-md-4">
              <label class="form-label small fw-semibold">Observación</label>
              <input v-model="nuevaGR.observacion" type="text" class="form-control form-control-sm" placeholder="Opcional…" />
            </div>
          </div>

          <div class="guide-preview mb-3" role="status">
            <span class="small text-muted">Guía en curso</span>
            <strong v-if="siguienteGuia">GR {{ siguienteGuia.serie }}-{{ siguienteGuia.numero }}</strong>
            <span v-else-if="cargandoNumero" class="small text-muted">Consultando correlativo...</span>
            <span v-else class="small text-danger">Sin serie configurada para este origen</span>
            <span class="small text-muted">El número definitivo se confirma al guardar.</span>
          </div>

          <!-- Buscador de productos -->
          <div class="card bg-light mb-2">
            <div class="card-body py-2">
              <div class="d-flex gap-2 align-items-center">
                <input v-model="busqProd" @input="buscarProductos" type="text"
                  class="form-control form-control-sm" style="max-width:320px"
                  placeholder="Buscar producto por nombre o código…" />
                <small class="text-muted" v-if="prodResultados.length">{{ prodResultados.length }} resultados</small>
              </div>
              <div v-if="prodResultados.length" class="mt-2 border bg-white transfer-results">
                <div class="table-responsive">
                <table class="table table-sm table-hover mb-0 transfer-search-table">
                  <thead class="table-light sticky-top"><tr>
                    <th>Cód. proveedor</th><th>Código de barras</th><th>Producto</th>
                    <th class="text-center">Presentación</th><th class="text-center">Talla</th>
                    <th class="text-center">Stock 939</th>
                    <th class="text-center">Stock 1179</th>
                    <th></th>
                  </tr></thead>
                  <tbody>
                    <tr v-for="p in prodResultados" :key="p.idpres">
                      <td class="font-monospace small text-nowrap fw-semibold">{{ p.codigo_prov || '—' }}</td>
                      <td class="font-monospace small text-nowrap">{{ p.codbarras || '—' }}</td>
                      <td class="small transfer-product-name">{{ p.nombre }}</td>
                      <td class="text-center small text-nowrap">{{ p.pres_nombre || '—' }}</td>
                      <td class="text-center fw-semibold text-nowrap">{{ p.usa || p.talla || '—' }}</td>
                      <td class="text-center small">{{ p.stock_t1 }}</td>
                      <td class="text-center small">{{ p.stock_t2 }}</td>
                      <td class="text-center">
                        <button @click="agregarItem(p)" class="btn btn-xs btn-outline-primary text-nowrap"
                          :disabled="nuevaGR.items.some(item => item.idpres === p.idpres)">
                          {{ nuevaGR.items.some(item => item.idpres === p.idpres) ? 'Agregado' : '+ Agregar' }}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </div>
            </div>
          </div>

          <!-- Líneas de la GR -->
          <div v-if="nuevaGR.items.length" class="table-responsive">
            <table class="table table-sm table-bordered mb-0">
              <thead class="table-light">
                <tr>
                  <th>Cód. proveedor</th>
                  <th>Código de barras</th>
                  <th>Producto</th>
                  <th class="text-center">Presentación</th>
                  <th class="text-center">Talla</th>
                  <th class="text-center" style="width:120px">Cantidad <span class="text-danger">*</span></th>
                  <th class="text-center" style="width:60px">Quitar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in nuevaGR.items" :key="item.idpres">
                  <td class="font-monospace small fw-semibold text-nowrap">{{ item.codigo_prov || '—' }}</td>
                  <td class="font-monospace small text-nowrap">{{ item.codbarras || '—' }}</td>
                  <td class="small transfer-product-name">{{ item.nombre }}</td>
                  <td class="small text-center text-nowrap">{{ item.presentacion || '—' }}</td>
                  <td class="small text-center fw-semibold text-nowrap">{{ item.talla || '—' }}</td>
                  <td class="text-center">
                    <input v-model.number="item.cantidad" type="number" min="1"
                      class="form-control form-control-sm text-center" style="width:80px;margin:0 auto" />
                  </td>
                  <td class="text-center">
                    <button @click="nuevaGR.items.splice(i,1)" class="btn btn-xs btn-outline-danger">
                      <img src="../../assets/img/icons/close-circle-2.svg" alt="×" style="width:16px" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-end mt-1">
              <small class="text-muted">{{ nuevaGR.items.length }} producto(s) · {{ nuevaGR.items.reduce((s,i)=>s+i.cantidad,0) }} unidades</small>
            </div>
          </div>
          <div v-else class="text-center py-3 text-muted small">
            Busca y agrega productos arriba.
          </div>

          <div v-if="errorNueva" class="alert alert-danger mt-2 py-2 small">{{ errorNueva }}</div>
        </div>
        <div class="modal-footer py-2">
          <small class="text-muted me-auto">El borrador no afecta stock. Luego deberás emitirla.</small>
          <button class="btn btn-sm btn-outline-secondary" @click="cerrarNueva">Cancelar</button>
          <button class="btn btn-sm btn-primary" :disabled="guardando" @click="guardarGR">
            <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
            Guardar borrador
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ─── Modal confirmar acción ────────────────────────────────── -->
  <div v-if="confirmModal" class="modal fade show d-block" style="background:rgba(0,0,0,.45);z-index:1060">
    <div class="modal-dialog modal-dialog-centered" style="max-width:440px">
      <div class="modal-content">
        <div class="modal-body p-4 text-center">
          <div class="fs-2 mb-2">
            <img :src="confirmModal.icon" style="width:32px" />
          </div>
          <h6 class="fw-bold">{{ confirmModal.titulo }}</h6>
          <p class="text-muted small mb-3">{{ confirmModal.mensaje }}</p>
          <div class="d-flex gap-2 justify-content-center">
            <button class="btn btn-sm btn-outline-secondary" @click="confirmModal=null">Cancelar</button>
            <button class="btn btn-sm" :class="confirmModal.btnClass" :disabled="procesando" @click="ejecutarAccion">
              <span v-if="procesando" class="spinner-border spinner-border-sm me-1"></span>
              {{ confirmModal.btnText }}
            </button>
          </div>
          <div v-if="confirmModal.error" class="alert alert-danger mt-2 py-1 small">{{ confirmModal.error }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader    from '../../components/Layouts/MainHeader.vue';
import MainSidebar   from '../../components/Layouts/MainSidebar.vue';
import BreadcrumbMenu from '../../components/Common/BreadcrumbMenu.vue';
import MainFooter    from '../../components/Layouts/MainFooter.vue';
import api from '../../services/api';

const HOY = new Date().toISOString().slice(0,10);

export default {
  name: 'TransferenciasGRPage',
  components: { MainHeader, MainSidebar, BreadcrumbMenu, MainFooter },
  data() {
    return {
      transferencias: [], total: 0, pagina: 1, pageSize: 30, cargando: false,
      filtros: { f1: '', f2: '', estadodoc: '', q: '' },
      stats: { total: 0, recepcionadas: 0, transito: 0, anuladas: 0 },
      debounceTimer: null,

      // detalle
      detalleModal: null, cargandoDetalle: false,

      // nueva GR
      nuevaModal: false,
      nuevaGR: { idorigen: 1, iddestino: 15, fecha_emision: HOY, observacion: '', items: [] },
      busqProd: '', prodResultados: [], busqTimer: null,
      guardando: false, errorNueva: '', siguienteGuia: null, cargandoNumero: false,

      // confirm
      confirmModal: null, procesando: false,
    };
  },
  computed: {
    totalPags() { return Math.ceil(this.total / this.pageSize); },
  },
  mounted() { this.cargar(); this.cargarStats(); },
  methods: {
    aplicarFechas() { this.pagina = 1; this.cargar(); },
    // ── Lista ──────────────────────────────────────────────────────
    buscarDebounced() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => { this.pagina=1; this.cargar(); }, 400);
    },
    async cargar() {
      this.cargando = true;
      try {
        const p = { page: this.pagina, limit: this.pageSize };
        if (this.filtros.f1)        p.f1        = this.filtros.f1;
        if (this.filtros.f2)        p.f2        = this.filtros.f2;
        if (this.filtros.estadodoc) p.estadodoc = this.filtros.estadodoc;
        if (this.filtros.q)         p.q         = this.filtros.q;
        const r = await api.get('/transferencias', { params: p });
        const d = r.data?.data ?? r.data;
        this.transferencias = Array.isArray(d) ? d : (d?.data ?? []);
        this.total = r.data?.pagination?.total ?? d?.total ?? this.transferencias.length;
      } catch(e) { console.error(e); this.transferencias = []; }
      finally { this.cargando = false; }
    },
    async cargarStats() {
      try {
        const [all,rec,tra,anu] = await Promise.all([
          api.get('/transferencias', { params:{limit:1} }),
          api.get('/transferencias', { params:{estadodoc:2,limit:1} }),
          api.get('/transferencias', { params:{estadodoc:1,estado:true,limit:1} }),
          api.get('/transferencias', { params:{estadodoc:3,limit:1} }),
        ]);
        const tot = r => r.data?.data?.total ?? r.data?.pagination?.total ?? 0;
        this.stats = { total:tot(all), recepcionadas:tot(rec), transito:tot(tra), anuladas:tot(anu) };
      } catch(e) { /* silencioso */ }
    },
    paginar(p) { this.pagina=p; this.cargar(); },
    limpiar() { this.filtros={f1:'',f2:'',estadodoc:'',q:''}; this.pagina=1; this.cargar(); },

    // ── Detalle ────────────────────────────────────────────────────
    async verDetalle(t) {
      this.detalleModal = { ...t, items:[] };
      this.cargandoDetalle = true;
      try {
        const r = await api.get(`/transferencias/${t.idreg}`);
        const d = r.data?.data ?? r.data;
        this.detalleModal = { ...d, items: d.items || d.detalles || [] };
      } catch(e) { console.error(e); }
      finally { this.cargandoDetalle = false; }
    },

    // ── Acciones (emitir / recepcionar / anular) ───────────────────
    accion(tipo, t) {
      const cfg = {
        emitir:      { titulo:'Emitir guía',       mensaje:`${this.numeroGuia(t)} pasará a En tránsito y descontará stock del almacén origen.`, btnText:'Emitir',       btnClass:'btn-primary',    icon:require('../../assets/img/icons/money-send.svg'), colorClass:'text-primary' },
        recepcionar: { titulo:'Recepcionar guía',   mensaje:`${this.numeroGuia(t)} será recepcionada. El stock se sumará al almacén destino.`,  btnText:'Recepcionar',  btnClass:'btn-success',    icon:require('../../assets/img/icons/check-icon.svg'), colorClass:'text-success' },
        anular:      { titulo:'Anular guía',        mensaje:`¿Seguro que deseas anular ${this.numeroGuia(t)}? Si está en tránsito, el stock del origen se restaurará.`, btnText:'Anular', btnClass:'btn-danger', icon:require('../../assets/img/icons/close-circle.svg'), colorClass:'text-danger' },
      }[tipo];
      this.confirmModal = { ...cfg, tipo, idreg: t.idreg, error: '' };
    },
    async ejecutarAccion() {
      if (!this.confirmModal) return;
      this.procesando = true;
      const { tipo, idreg } = this.confirmModal;
      try {
        if (tipo === 'recepcionar') {
          await api.post(`/transferencias/${idreg}/recepcionar`, {});
        } else {
          await api.post(`/transferencias/${idreg}/${tipo}`, {});
        }
        this.confirmModal = null;
        this.cargar();
        this.cargarStats();
      } catch(e) {
        this.confirmModal.error = e.response?.data?.error || e.response?.data?.message || 'Error al procesar';
      } finally { this.procesando = false; }
    },

    // ── Nueva GR ───────────────────────────────────────────────────
    abrirNueva() {
      this.nuevaGR = { idorigen:1, iddestino:15, fecha_emision:HOY, observacion:'', items:[] };
      this.busqProd = ''; this.prodResultados = []; this.errorNueva = '';
      this.nuevaModal = true;
      this.cargarSiguienteNumero();
    },
    cerrarNueva() { this.nuevaModal=false; this.busqProd=''; this.prodResultados=[]; },
    buscarProductos() {
      clearTimeout(this.busqTimer);
      if (!this.busqProd.trim()) { this.prodResultados=[]; return; }
      this.busqTimer = setTimeout(async () => {
        try {
          const r = await api.get('/productos', { params:{ q:this.busqProd, limit:20, publicado:false } });
          const d = r.data?.data ?? r.data;
          const rows = Array.isArray(d) ? d : (d?.data ?? []);
          this.prodResultados = rows;
        } catch(e) { this.prodResultados=[]; }
      }, 350);
    },
    async cargarSiguienteNumero() {
      this.siguienteGuia = null;
      this.errorNueva = '';
      if (!this.nuevaGR.idorigen) return;
      this.cargandoNumero = true;
      try {
        const r = await api.get('/transferencias/siguiente-numero', { params:{ idorigen:this.nuevaGR.idorigen } });
        this.siguienteGuia = r.data?.data ?? r.data;
      } catch (e) {
        this.errorNueva = e.response?.data?.error || e.response?.data?.message || 'No se pudo consultar el correlativo.';
      } finally { this.cargandoNumero = false; }
    },
    agregarItem(p) {
      if (this.nuevaGR.items.find(i => i.idpres === p.idpres)) return;
      this.nuevaGR.items.push({
        idpres: p.idpres,
        codigo_prov: p.codigo_prov,
        codbarras: p.codbarras,
        nombre: p.nombre || p.producto,
        presentacion: p.pres_nombre,
        talla: p.usa || p.talla,
        cantidad: 1,
      });
    },
    async guardarGR() {
      this.errorNueva = '';
      if (!this.nuevaGR.idorigen || !this.nuevaGR.iddestino) { this.errorNueva = 'Selecciona origen y destino.'; return; }
      if (this.nuevaGR.idorigen === this.nuevaGR.iddestino) { this.errorNueva = 'Origen y destino deben ser distintos.'; return; }
      if (!this.nuevaGR.fecha_emision) { this.errorNueva = 'Indica la fecha.'; return; }
      if (!this.nuevaGR.items.length) { this.errorNueva = 'Agrega al menos un producto.'; return; }
      const invalidos = this.nuevaGR.items.filter(i => !i.cantidad || i.cantidad < 1);
      if (invalidos.length) { this.errorNueva = 'Todas las cantidades deben ser ≥ 1.'; return; }
      this.guardando = true;
      try {
        await api.post('/transferencias', {
          idorigen:      this.nuevaGR.idorigen,
          iddestino:     this.nuevaGR.iddestino,
          fecha_emision: this.nuevaGR.fecha_emision,
          observacion:   this.nuevaGR.observacion || undefined,
          items: this.nuevaGR.items.map(i => ({ idpres: i.idpres, cantidad: i.cantidad })),
        });
        this.cerrarNueva();
        this.cargar();
        this.cargarStats();
      } catch(e) {
        this.errorNueva = e.response?.data?.error || e.response?.data?.message || 'Error al guardar';
      } finally { this.guardando = false; }
    },

    // ── Helpers ────────────────────────────────────────────────────
    estadoLabel(estadodoc, estado) {
      if (estadodoc===3) return 'Anulada';
      if (estadodoc===2) return 'Recepcionada';
      return estado ? 'En tránsito' : 'Borrador';
    },
    numeroGuia(t) {
      return t?.serie && t?.numero
        ? `GR ${t.serie}-${t.numero}`
        : `GR SIN NÚMERO (#${t?.idreg || 'sin ID'})`;
    },
    estadoClass(estadodoc, estado) {
      if (estadodoc===3) return 'badge bg-danger-subtle text-danger';
      if (estadodoc===2) return 'badge bg-success-subtle text-success';
      if (estado)        return 'badge bg-warning-subtle text-warning';
      return 'badge bg-secondary-subtle text-secondary';
    },
    fmtFecha(f) {
      if (!f) return '—';
      return new Date(f).toLocaleDateString('es-PE', { day:'2-digit', month:'2-digit', year:'numeric' });
    },
  },
};
</script>

<style scoped>
.transfer-product-name {
  min-width: 260px;
  white-space: normal;
  overflow-wrap: anywhere;
}
.transfer-create-dialog {
  max-width: min(1180px, calc(100vw - 24px));
  margin: 12px auto;
}
.transfer-create-modal {
  max-height: calc(100vh - 24px);
  overflow: hidden;
}
.transfer-create-modal .modal-body {
  overflow-y: auto;
  min-height: 0;
}
.transfer-create-modal .modal-header,
.transfer-create-modal .modal-footer {
  flex-shrink: 0;
}
.transfer-results {
  max-height: min(280px, 34vh);
  overflow-y: auto;
}
.guide-preview {
  display: grid;
  grid-template-columns: auto auto 1fr;
  align-items: center;
  gap: 6px 12px;
  padding: 8px 12px;
  border: 1px solid #d9e2ec;
  background: #f8fafc;
}
.transfer-search-table {
  min-width: 980px;
}
@media (max-width: 767px) {
  .transfer-create-dialog { margin: 6px auto; max-width: calc(100vw - 12px); }
  .transfer-create-modal { max-height: calc(100vh - 12px); }
  .transfer-create-modal .modal-footer small { display: none; }
  .guide-preview { grid-template-columns: 1fr; }
}
</style>
